import React from 'react';
import ReactDOMServer from 'react-dom/server';

var PracticeScenarioAStartText =
	<div>
		<br />Below are the main points that you will practice during this scenario:<br />
		<ul>
			<li>Assess the area and ask a bystander to call 911.</li>
			<li>Wear personal protective equipment.</li>
			<li>Select the appropriate pressure dressing.</li>
			<li>Apply the pressure dressing over the wound.</li>
			<li>Apply pressure to the wound with the pressure dressing.</li>
			<li>If the bleeding is not controlled, don’t remove the dressing.</li>
			<li>Reassess for Bleeding Control – after pressure dressing.</li>
		</ul>
			Please tap on the Start Scenario button below to start this practice scenario.
	</div>;

var PracticeScenarioBStartText =
	<div>
		<br />Below are the main points that you will practice during this practice scenario:<br />
		<ul>
			<li>Assess the area and ask a bystander to call 911.</li>
			<li>Wear personal protective equipment.</li>
			<li>Select the appropriate pressure dressing.</li>
			<li>Apply the pressure dressing over the wound.</li>
			<li>Apply pressure to the wound with the pressure dressing.</li>
			<li>If the bleeding is not controlled, don’t remove the dressing.</li>
			<li>Reassess for Bleeding Control – after pressure dressing.</li>
			<li>Identify and apply the 1st tourniquet on the correct location.</li>
			<li>Twist the Rod until the bleeding has stopped.</li>
			<li>Reassess for Bleeding Control – after 1st tourniquet.</li>
			<li>Record time of application of 1st tourniquet.</li>
		</ul>
			Please tap on the Start Scenario button below to start this practice scenario.
	</div>;

var PracticeScenarioCStartText =
	<div>
		Below are the main points that you will practice during this practice scenario:
		<ul>
			<li>Assess the area and ask a bystander to call 911.</li>
			<li>Wear personal protective equipment.</li>
			<li>Select the appropriate pressure dressing.</li>
			<li>Apply the pressure dressing over the wound.</li>
			<li>Apply pressure to the wound with the pressure dressing.</li>
			<li>If the bleeding is not controlled, don’t remove the dressing.</li>
			<li>Reassess for Bleeding Control – after pressure dressing.</li>
			<li>Identify and apply the 1st tourniquet on the correct location.</li>
			<li>Twist the Rod until the bleeding has stopped.</li>
			<li>Reassess for Bleeding Control – after 1st tourniquet.</li>
			<li>Record time of application of 1st tourniquet.</li>
			<li>Identify and apply the 2nd tourniquet on the correct location.</li>
			<li>Twist the Rod until the bleeding has stopped.</li>
			<li>Reassess for Bleeding Control – after 2nd tourniquet.</li>
			<li>Record time of application of 2nd tourniquet.</li>
		</ul>
	</div>;


var PracticeScenarioDStartText =
	<div>
		<br />Below are the main points that you will practice during this practice scenario:<br />
		<ul>
			<li>Assess the area and ask a bystander to call 911.</li>
			<li>Wear personal protective equipment.</li>
			<li>Identify and apply the 1st tourniquet on the correct location.</li>
			<li>Twist the Rod until the bleeding has stopped.</li>
			<li>Reassess for Bleeding Control – after 1st tourniquet.</li>
			<li>Record time of application of 1st tourniquet.</li>
			<li>Identify and apply the 2nd tourniquet on the correct location.</li>
			<li>Twist the Rod until the bleeding has stopped.</li>
			<li>Reassess for Bleeding Control – after 2nd tourniquet.</li>
			<li>Record time of application of 2nd tourniquet.</li>
		</ul>
		Please tap on the Start Scenario button below to start this practice scenario.
	</div>;

export const getPracticeAScenario = function(){
	return ReactDOMServer.renderToStaticMarkup(PracticeScenarioAStartText);
};

export const getPracticeBScenario = function(){
	return ReactDOMServer.renderToStaticMarkup(PracticeScenarioBStartText);
};

export const getPracticeCScenario = function(){
	return ReactDOMServer.renderToStaticMarkup(PracticeScenarioCStartText);
};

export const getPracticeDScenario = function(){
	return ReactDOMServer.renderToStaticMarkup(PracticeScenarioDStartText);
};
